/**
 * ゼロ幅文字を含む不可視文字を除去してtrimする
 */
export function trimWithInvisibleChars(str: string): string {
  if (!str) return ''

  // ゼロ幅文字を除去
  return str
    .replace(/\u200B/g, '') // ゼロ幅スペース
    .replace(/\u200C/g, '') // ゼロ幅非接合子
    .replace(/\u200D/g, '') // ゼロ幅接合子
    .replace(/\uFEFF/g, '') // ゼロ幅ノーブレークスペース（BOM）
    .trim()
}

/**
 * URL からファイル名（クエリ・ハッシュを除いた末尾のパスセグメント）を取り出す
 */
export function extractFileName(url: string): string {
  if (!url) return ''
  return url.split(/[?#]/)[0].split('/').pop() ?? ''
}

/**
 * 外部入力 URL の サニタイズ処理.
 */
export function sanitizeHttpUrl(url: string | null | undefined): string | null {
  if (!url) return null
  return /^https?:\/\//.test(url) ? url : null
}
